export const USER_ROLES = {
  ADMIN: "ADMIN",
  STUDENT: "STUDENT",
  CONTENT_CREATOR: "CONTENT_CREATOR",
  GUARDIAN: "GUARDIAN",
} as const;

export type UserRoleType = (typeof USER_ROLES)[keyof typeof USER_ROLES];
